/**
 * Initialise hover behaviour on the brands page — show brand info on mouseenter.
 */
function initBrandHover() {
    const brands = document.querySelectorAll(
        ".page-brands .lux-brands-wrapper .lux-brand",
    );
    const luxRight = document.querySelector(
        ".page-brands .lux-brands-container .lux-right",
    );

    if (!brands.length || !luxRight) return;

    brands.forEach(function (brand) {
        brand.addEventListener("mouseenter", function () {
            const brandWrapper = brand.closest(".lux-brand-wrapper");
            if (!brandWrapper) return;

            const brandInfo = brandWrapper.querySelector(".lux-brand-info");
            if (!brandInfo) return;

            luxRight.replaceChildren(brandInfo.cloneNode(true));
        });
    });
}

if (document.querySelector(".page-brands")) {
    initBrandHover();
}
